__turbopack_context__.v({
  "Form": "table-search-module___jHGpW__Form",
});
